/**
 * ============================================================================
 * CUSTOMER DEMO BOOKING SERVICE - TEMPORARILY ON HOLD
 * ============================================================================
 * 
 * This service is part of the "Book Demo" feature that is currently on hold.
 * The code is preserved here for future restoration.
 * 
 * To restore this feature:
 * 1. Uncomment the backend routes in routes/api.php
 * 2. Uncomment the Book Demo button in TutorCard.jsx
 * 3. Uncomment the route in App.js for /customer/book-demo/:tutorId
 * 4. Uncomment the component code in BookDemo.jsx
 * 
 * ============================================================================
 */

import { customerApi } from './api';

export const customerDemoBookingService = {
  bookDemo: async (data) => {
    const response = await customerApi.post('/book-demo', data);
    return response.data;
  },

  getBookings: async () => {
    const response = await customerApi.get('/demo-bookings');
    return response.data;
  },

  getBooking: async (id) => {
    const response = await customerApi.get(`/demo-bookings/${id}`);
    return response.data;
  },

  getStatistics: async () => {
    const response = await customerApi.get('/demo-bookings/statistics');
    return response.data;
  },

  cancelBooking: async (id) => {
    const response = await customerApi.patch(`/demo-bookings/${id}/cancel`);
    return response.data;
  },
};
